// extracted by mini-css-extract-plugin
module.exports = {"baseBoxShadow":"0 5px 38px 0 rgba(25,27,61,0.1)"};